<template lang="pug">
    div
        SearchProcessos(
          placeHolder="Informe o número ou o tipo de processo"
          :statusRetificacao="true",
          @search="search",
          @advancedSearch="advancedSearch",
          @clear="clear",
        )
        ListagemProcessos(
          headerLabel="Listagem de processos"
          :loading="loading",
          :isBusca="isBusca",
          :isCentral="false",
          @carregaProcessos="carregaProcessos",
          @sort="sort",
          :processos="processos"
          @goTo="goTo"
        )
          app-paginacao(
            :total="totalProcessos",
            :pagina="filtro.pagina",
            @changePage="changePage"
          )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppPaginacao from '@/components/AppPaginacao'
import SearchProcessos from '@/screens/central/processos/SearchProcessos.vue'
import ListagemProcessos from '@/screens/central/processos/ListagemProcessos.vue'
import FILTRO_EMPTY from '@/models/filtro'

export default {

  components: {
    SearchProcessos,
    ListagemProcessos,
    AppPaginacao
  },

  data () {
    return {
      filtro: FILTRO_EMPTY('LISTAGEM_RECEPTOR'),
      totalProcessos: 0,
      isBusca: false,
      loading: false,
      processos: []
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogin: 'auth/usuarioLogado'
    })
  },

  async created () {
    this.carregaProcessos()
  },

  methods: {
    ...mapActions({
      getByFilterReceptor: 'processos/getByFilterReceptor'
    }),

    changePage (newPage) {
      this.filtro.pagina = newPage
      this.findProcessos()
    },

    async findProcessos () {
      this.loading = true
      const result = await this.getByFilterReceptor(this.filtro)
      if (result.content) {
        this.processos = result.content
      }
      this.totalProcessos = result.totalElements
      this.loading = false
    },

    carregaProcessos () {
      this.clearFiltro()
      this.isBusca = false
      this.findProcessos()
    },

    sort (data) {
      this.isBusca = true
      this.filtro.pagina = 0
      this.filtro.ordem = data.ordenacao
      this.filtro.ordemDirecao = data.tipo

      this.findProcessos()
    },

    clear () {
      this.isBusca = false
      this.clearFiltro()

      this.carregaProcessos()
    },

    clearFiltro () {
      this.filtro = FILTRO_EMPTY('LISTAGEM_RECEPTOR')
    },

    search (param) {
      this.isBusca = true
      this.filtro.campoSimples = param
      this.filtro.simplificado = true
      this.filtro.pagina = 0

      this.findProcessos()
    },

    advancedSearch (filtroAtualizado) {
      this.isBusca = true
      this.filtro.numeroProcesso = filtroAtualizado.numeroProcesso
      this.filtro.cpfCnpjInteressado = filtroAtualizado.cpfCnpj
      this.filtro.nomeInteressado = filtroAtualizado.nomeRazaoSocial
      this.filtro.tipo = filtroAtualizado.tipo || null
      this.filtro.status = filtroAtualizado.status || null
      this.filtro.simplificado = false
      this.filtro.pagina = 0

      this.findProcessos()
    },
    goTo (data, setLoader, resetLoader) {
      setLoader()
      this.$router.push({
        name: 'detalhes-processo-receptor',
        params: {
          idCadastro: data.numeroProtocolo,
          numeroProcesso: data.numeroProcesso,
          id: data.id
        }
      }, () => {
        resetLoader()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-processos {
    flex: 1;
    padding: 20px;
  }

  .processos-header {
    display: inline-flex;
    align-items: start;
    padding: 10px 0;
  }

  .processos-main {
    padding: 10px 0;
  }

  .busca-processos {
    padding: 10px 0;
  }

  .listagem-processos {
    padding: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/screens/receptor/Listagem.vue